import { useState } from "react";
import { FaMapMarkerAlt, FaPhoneAlt, FaWhatsapp, FaEnvelope } from "react-icons/fa";

const quickContacts = [
  {
    title: "Phone",
    value: "+91 98407 77003",
    icon: <FaPhoneAlt className="h-5 w-5 text-emerald-300" />,
    href: "tel:+919840777003",
  },
  {
    title: "WhatsApp",
    value: "+91 98407 77003",
    icon: <FaWhatsapp className="h-5 w-5 text-emerald-300" />,
    href: "https://wa.me/919840777003",
  },
  {
    title: "Email",
    value: "info@kgshuttlecourt.com",
    icon: <FaEnvelope className="h-5 w-5 text-emerald-300" />,
    href: "mailto:info@kgshuttlecourt.com",
  },
  {
    title: "Address",
    value: "Veleaswaran Nagar Main Road, Mangadu, Chennai",
    icon: <FaMapMarkerAlt className="h-5 w-5 text-emerald-300" />,
    href: "https://www.google.com/maps?q=KG+batminton+court",
  },
];

const ContactSection = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });

  const handleSubmit = (event) => {
    event.preventDefault();
    alert("Thanks for your message. We'll follow up with you shortly.");
    setForm({ name: "", email: "", message: "" });
  };

  return (
    <section id="contact" className="mx-auto max-w-7xl px-6 py-20 sm:px-8 lg:px-12">
      <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr]">
        <div className="space-y-8">
          <div>
            <p className="text-sm uppercase tracking-[0.32em] text-emerald-300">Contact</p>
            <h2 className="section-heading mt-4">Get in touch with KG Shuttle Court.</h2>
            <p className="section-copy">
              Call now to check availability for regular play and coaching. Our team is ready to help you secure the best court slot in Mangadu.
            </p>
          </div>
          <div className="rounded-[2rem] border border-white/10 bg-slate-900/80 p-6 shadow-[0_28px_60px_rgba(15,23,42,0.35)]">
            <p className="text-sm uppercase tracking-[0.32em] text-emerald-300">Session Hours</p>
            <div className="mt-4 grid gap-4 sm:grid-cols-2">
              <div className="rounded-3xl bg-slate-950/80 p-5">
                <p className="text-sm uppercase tracking-[0.32em] text-slate-400">Regular Play</p>
                <p className="mt-2 text-lg font-semibold text-white">Daily | 5:00 AM – 11:00 PM</p>
                <p className="mt-2 text-sm text-slate-400">1 hour per session</p>
              </div>
              <div className="rounded-3xl bg-slate-950/80 p-5">
                <p className="text-sm uppercase tracking-[0.32em] text-slate-400">Coaching</p>
                <p className="mt-2 text-lg font-semibold text-white">Mon – Sat | 5:00 PM – 7:00 PM</p>
                <p className="mt-2 text-sm text-slate-400">Guided by professional coaches</p>
              </div>
            </div>
          </div>

          <div className="grid gap-4 sm:grid-cols-2">
            {quickContacts.map((item) => (
              <a
                key={item.title}
                href={item.href}
                target="_blank"
                rel="noreferrer"
                className="section-card flex items-start gap-4 transition hover:-translate-y-1 hover:border-emerald-400/20"
              >
                <div className="mt-1">{item.icon}</div>
                <div>
                  <p className="text-sm uppercase tracking-[0.32em] text-slate-400">{item.title}</p>
                  <p className="mt-2 text-base text-white">{item.value}</p>
                </div>
              </a>
            ))}
          </div>

          <div className="overflow-hidden rounded-[2rem] border border-white/10 bg-slate-950/80 shadow-glass">
            <iframe
              title="KG Shuttle Court location"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15548.34514526084!2d80.1158469!3d13.030177!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a52619031756e61%3A0xe7529b08184f535a!2sKG%20batminton%20court!5e0!3m2!1sen!2sin!4v1687271219313!5m2!1sen!2sin"
              className="h-96 w-full border-0"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>

        <div className="glass-panel p-8">
          <div className="space-y-6">
            <p className="text-sm uppercase tracking-[0.32em] text-emerald-300">Send a message</p>
            <h3 className="text-3xl font-semibold text-white">Book your next session or ask a question.</h3>
            <p className="text-slate-400">Fill out the form below and our booking team will respond within 24 hours.</p>
          </div>

          <form onSubmit={handleSubmit} className="mt-8 space-y-6">
            <label className="block text-sm text-slate-200">
              Full name
              <input
                type="text"
                value={form.name}
                onChange={(event) => setForm({ ...form, name: event.target.value })}
                required
                className="mt-3 w-full rounded-3xl border border-white/10 bg-slate-950/80 px-4 py-3 text-slate-100 outline-none transition focus:border-emerald-400 focus:ring-2 focus:ring-emerald-400/20"
                placeholder="Your full name"
              />
            </label>

            <label className="block text-sm text-slate-200">
              Email address
              <input
                type="email"
                value={form.email}
                onChange={(event) => setForm({ ...form, email: event.target.value })}
                required
                className="mt-3 w-full rounded-3xl border border-white/10 bg-slate-950/80 px-4 py-3 text-slate-100 outline-none transition focus:border-emerald-400 focus:ring-2 focus:ring-emerald-400/20"
                placeholder="you@example.com"
              />
            </label>

            <label className="block text-sm text-slate-200">
              Message
              <textarea
                value={form.message}
                onChange={(event) => setForm({ ...form, message: event.target.value })}
                required
                rows={5}
                className="mt-3 w-full rounded-[1.5rem] border border-white/10 bg-slate-950/80 px-4 py-3 text-slate-100 outline-none transition focus:border-emerald-400 focus:ring-2 focus:ring-emerald-400/20"
                placeholder="Tell us what you'd like to book or ask about"
              />
            </label>

            <button type="submit" className="btn-primary w-full py-3 text-base">
              Send Message
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
